// Where the visitor is, so the demo speaks their currency and their payment rail.
const REGIONS = {
  QA: { label: "Qatar", currency: "QAR", symbol: "﷼", rail: "QATCH",
        rails: ["QAR · QATCH", "USD · ACH", "EUR · SEPA"], balance: "830,637.81" },
  AE: { label: "the UAE", currency: "AED", symbol: "د.إ", rail: "UAEFTS / IPP",
        rails: ["AED · UAEFTS", "USD · ACH", "GBP · Faster Payments"], balance: "838,120.50" },
  SA: { label: "Saudi Arabia", currency: "SAR", symbol: "﷼", rail: "SARIE",
        rails: ["SAR · SARIE", "USD · ACH", "EUR · SEPA"], balance: "856,468.70" },
  GB: { label: "the UK", currency: "GBP", symbol: "£", rail: "Faster Payments",
        rails: ["GBP · Faster Payments", "EUR · SEPA", "USD · ACH"], balance: "180,296.40" },
  US: { label: "the US", currency: "USD", symbol: "$", rail: "ACH / FedWire",
        rails: ["USD · ACH", "EUR · SEPA", "GBP · Faster Payments"], balance: "228,211.65" },
  EU: { label: "the eurozone", currency: "EUR", symbol: "€", rail: "SEPA Instant",
        rails: ["EUR · SEPA Instant", "USD · ACH", "GBP · Faster Payments"], balance: "209,954.72" },
  TR: { label: "Türkiye", currency: "TRY", symbol: "₺", rail: "FAST",
        rails: ["TRY · FAST", "EUR · SEPA", "USD · ACH"], balance: "9,470,783.48" },
  IN: { label: "India", currency: "INR", symbol: "₹", rail: "IMPS / UPI",
        rails: ["INR · UPI", "USD · ACH", "AED · UAEFTS"], balance: "19,740,307.75" },
  PK: { label: "Pakistan", currency: "PKR", symbol: "₨", rail: "RAAST",
        rails: ["PKR · RAAST", "USD · ACH", "SAR · SARIE"], balance: "63,899,262.00" },
  SG: { label: "Singapore", currency: "SGD", symbol: "S$", rail: "FAST / PayNow",
        rails: ["SGD · FAST", "USD · ACH", "EUR · SEPA"], balance: "305,803.61" },
};

const TZ_REGION = {
  "Asia/Qatar": "QA", "Asia/Bahrain": "QA", "Asia/Dubai": "AE", "Asia/Muscat": "AE",
  "Asia/Riyadh": "SA", "Asia/Kuwait": "SA", "Europe/London": "GB", "Europe/Dublin": "GB",
  "Europe/Istanbul": "TR", "Asia/Kolkata": "IN", "Asia/Calcutta": "IN", "Asia/Karachi": "PK",
  "Asia/Singapore": "SG", "Asia/Kuala_Lumpur": "SG",
};

const LOCALE_REGION = {
  QA: "QA", AE: "AE", SA: "SA", GB: "GB", US: "US", TR: "TR", IN: "IN", PK: "PK", SG: "SG",
  DE: "EU", FR: "EU", NL: "EU", ES: "EU", IT: "EU", IE: "EU", PT: "EU", BE: "EU", AT: "EU",
};

/** Best guess at the visitor's region from their locale, then their timezone. */
export function detectRegion() {
  try {
    const loc = navigator.language || "";
    const cc = loc.split("-")[1]?.toUpperCase();
    if (cc && LOCALE_REGION[cc]) return REGIONS[LOCALE_REGION[cc]];
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TZ_REGION[tz]) return REGIONS[TZ_REGION[tz]];
    if (tz?.startsWith("Europe/")) return REGIONS.EU;
    if (tz?.startsWith("America/")) return REGIONS.US;
  } catch (e) { console.warn("Region lookup failed, defaulting to the Gulf:", e); }
  return REGIONS.QA;
}

export { REGIONS };
